import { Block } from '../stores/models';

export const isSlider = (question: Block) =>
  question.questionType?.includes('slider') &&
  question.scaleMin !== undefined &&
  question.scaleMax !== undefined;

export const isTextarea = (question: Block) =>
  question.questionType?.includes('textarea');
